import { Component, OnInit } from '@angular/core';
import { PopoverController, ToastController } from '@ionic/angular';
import { CONFIGURATIONS } from 'src/constant/constantes';

@Component({
  selector: 'app-subiraudio',
  templateUrl: './subiraudio.component.html',
  styleUrls: ['./subiraudio.component.scss'],
})
export class SubiraudioComponent implements OnInit {
private readonly MAX_DURATION_SECONDS = 360; // 5 minutos
  private readonly MAX_SIZE_BYTES = 7 * 1024 * 1024; // 5 MB
  sizeAudio = this.MAX_SIZE_BYTES;

  selectedFile: File | null = null;
  errorMsg: string | null = null;
  tiempoMax: string = '';

  constructor(public poper: PopoverController, private toastCtrl: ToastController) { }

  ngOnInit() {
    let tiempoMax = CONFIGURATIONS.tiempoMaximoAudio; // ejemplo en milisegundos
    let totalSegundos = Math.floor(tiempoMax / 1000); 

    let minutos = Math.floor(totalSegundos / 60);
    let segundos = totalSegundos % 60;

    // Aseguramos que los segundos siempre tengan dos dígitos
    let formato = `${minutos}:${segundos.toString().padStart(2, '0')}`;
    this.tiempoMax = formato;
  }

   async cerarPopOver(){  
    this.poper.dismiss(); 
  }

    async onAudioFileChange(event: Event): Promise<void> {
    this.errorMsg = null;
    this.selectedFile = null;

    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    // 1) Validar tamaño
    if (file.size > this.MAX_SIZE_BYTES) {
      this.errorMsg = 'El archivo supera los ' + (this.MAX_SIZE_BYTES / 1024 / 1024) + ' MB.';
      await this.showToast(this.errorMsg, 'danger');
      return;
    }

    // 2) Validar duración
    const url = URL.createObjectURL(file);
    try {
      const duration = await this.getAudioDurationSeconds(url);
      if (duration > this.MAX_DURATION_SECONDS) {
        this.errorMsg = 'La duración supera los 6 minutos.';
        await this.showToast(this.errorMsg, 'danger');
        return;
      }

      this.selectedFile = file;
      await this.showToast('Audio válido y listo para subir.', 'success');
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  async uploadSelectedAudio(): Promise<void> {
    if (!this.selectedFile) return;

    // Aquí iría tu lógica real de subida
     this.poper.dismiss({      
      audio : this.selectedFile
    }); 
    await this.showToast('Audio agregado correctamente.', 'success');
    this.selectedFile = null;
  }

  private getAudioDurationSeconds(src: string): Promise<number> {
    return new Promise((resolve, reject) => {
      const audio = new Audio();
      audio.preload = 'metadata';

      audio.onloadedmetadata = () => resolve(audio.duration);
      audio.onerror = () => reject('Error al leer duración del audio');

      audio.src = src;
    });
  }

  private async showToast(message: string, color: 'success' | 'danger' | 'warning') {
    const toast = await this.toastCtrl.create({
      message,
      color,
      duration: 2000,
      position: 'bottom',
    });
    await toast.present();
  }
}
